import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLocale } from "../i18n/LocaleContext";
import { CATEGORIES } from "../data/treatments";
import { Reveal, Eyebrow } from "../components/Reveal";

export default function Treatments() {
  const { t, link, lang } = useLocale();

  return (
    <div data-testid="treatments-page">
      <section className="mx-auto max-w-[1600px] px-6 pb-10 pt-40 sm:px-10 lg:px-16 lg:pt-52">
        <Reveal>
          <Eyebrow>{t("treatmentsPage.eyebrow")}</Eyebrow>
          <h1 className="mt-6 max-w-3xl font-serif text-5xl font-light leading-tight text-imperium-black sm:text-6xl">{t("treatmentsPage.title")}</h1>
          <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-imperium-black/70">{t("treatmentsPage.intro")}</p>
        </Reveal>
      </section>
      <section className="mx-auto max-w-[1600px] px-6 py-16 sm:px-10 lg:px-16 lg:py-24">
        <div className="flex flex-col gap-24 lg:gap-32">
          {CATEGORIES.map((cat, i) => (
            <Reveal key={cat.key}>
              <div className="grid items-center gap-10 lg:grid-cols-12" data-testid={`category-block-${cat.key}`}>
                <div className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                  <Link to={link("treatments", cat.slugs[lang])} className="group block overflow-hidden" data-testid={`category-image-link-${cat.key}`}>
                    <img src={cat.img} alt={cat.names[lang]} loading="lazy" className="aspect-[4/5] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                  </Link>
                </div>
                <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1 lg:pr-10" : "lg:col-start-7"}`}>
                  <span className="font-serif italic text-2xl text-imperium-champagne">{String(i + 1).padStart(2, "0")}</span>
                  <h2 className="mt-4 font-serif text-3xl font-light text-imperium-black sm:text-5xl">{cat.names[lang]}</h2>
                  <div className="mt-5 h-px w-16 bg-imperium-gold" aria-hidden="true" />
                  <p className="mt-6 max-w-md text-base font-light leading-relaxed text-imperium-black/70">{cat.desc[lang]}</p>
                  <Link
                    to={link("treatments", cat.slugs[lang])}
                    data-testid={`category-more-${cat.key}`}
                    className="group mt-8 inline-flex items-center gap-2 text-[11px] font-label uppercase tracking-[0.25em] text-imperium-brown"
                  >
                    <span className="link-line">{t("cta.readMore")}</span>
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:rotate-45" />
                  </Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
